<div class="container-fluid p-0 m-0">
    <app-shared [type]="'retour-fournisseur'" [status]="'Annulé'"></app-shared>
</div>
